import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {UncontrolledTooltip, Popover, PopoverBody} from 'reactstrap';
import cloneDeep from 'lodash/cloneDeep';
import CreateEditScoreSet from './CreateEditScoreSet';

import modalService from '../../../../components/modal/modalService';
import Dropdown from '../../../../components/Dropdown';
import PageCommands from '../../../../modules/app/layout/PageCommands';
import UseBackButton from '../../../../modules/app/layout/UseBackButton';


class ScoreSetsHeader extends Component {
  constructor(props){
    super(props);
    this.state = {
      showEditDelete: false
    };
    this.createOrEditDialog = this.createOrEditDialog.bind(this);
    this.onScoreSelect = this.onScoreSelect.bind(this);
    this.onShowEditDeleteOverlay = this.onShowEditDeleteOverlay.bind(this);
    this.onEditClick = this.onEditClick.bind(this);
    this.onCloneClick = this.onCloneClick.bind(this);
    this.onDeleteClick = this.onDeleteClick.bind(this);
    this.onCreateScoreSet = this.onCreateScoreSet.bind(this);
    this.onEditScoreSet = this.onEditScoreSet.bind(this);
  }

  createOrEditDialog(type, scoreSet, scoreSets, scoreSetTemplate, scoreSetsDefaults, accounts, verticals){
    return (
      <CreateEditScoreSet
        type={type}
        accounts={accounts}
        verticals={verticals}
        scoreSetsDefaults={scoreSetsDefaults}
        scoreSets={scoreSets}
        scoreSet={scoreSet}
        scoreConfigTemplate={scoreSetTemplate}
        onCreate={this.onCreateScoreSet}
        onSave={this.onEditScoreSet}/>
    );
  }

  onShowEditDeleteOverlay(){
    this.setState({ showEditDelete: !this.state.showEditDelete });
  }

  onScoreSelect(e){
    const { scoreSets, onSelectedScoreSetChange } = this.props;
    onSelectedScoreSetChange(scoreSets.indexOf(e));
  }

  onEditClick(){
    const {accounts, verticals, scoreSets, selectedScoreSetIndex, scoreSetsDefaults} = this.props;
    modalService.requestModalComponent(this.createOrEditDialog(CreateEditScoreSet.Types.EDIT, scoreSets[selectedScoreSetIndex], scoreSets, scoreSets[selectedScoreSetIndex], scoreSetsDefaults,  accounts, verticals), undefined, undefined, 'static');
    this.setState({ showEditDelete: false });
  }

  onCloneClick(){
    const {accounts, verticals, scoreSets, selectedScoreSetIndex, scoreSetsDefaults} = this.props;
    const template = cloneDeep(scoreSets[selectedScoreSetIndex]);
    modalService.requestModalComponent(this.createOrEditDialog(CreateEditScoreSet.Types.CLONE, scoreSets[selectedScoreSetIndex], scoreSets, template, scoreSetsDefaults,  accounts, verticals), undefined, undefined, 'static');
    this.setState({ showEditDelete: false });
  }

  onCreateClick(){
    const {accounts, verticals, scoreSets, selectedScoreSetIndex, scoreSetsDefaults} = this.props;
    modalService.requestModalComponent(this.createOrEditDialog(CreateEditScoreSet.Types.CREATE, null, scoreSets, scoreSets[selectedScoreSetIndex], scoreSetsDefaults, accounts, verticals), undefined, undefined, 'static');
  }

  onDeleteClick(){
    //TODO - confirmation!
    const {scoreSets, selectedScoreSetIndex } = this.props;
    this.props.onDeleteScoreSet(scoreSets[selectedScoreSetIndex]);
  }

  onCreateScoreSet(scoreSet){
    this.props.onCreateScoreSet(scoreSet);
    modalService.closeModal();
  }

  onEditScoreSet(scoreSet){
    this.props.onEditScoreSet(scoreSet);
    modalService.closeModal();
  }

  render() {
    const { accounts, scoreSets, selectedScoreSetIndex, scoreConfigTemplate, verticals, requesting } = this.props;
    const scoreSet = scoreSets[selectedScoreSetIndex];
    let deleteOption;
    if(!scoreSet.scoreConfig.isDefault && scoreSets.filter(ss => !ss.scoreConfig.isDefault).length){
      deleteOption = (<button className="dropdown-item ecd-option" onClick={this.onDeleteClick}><i className="fas fa-trash-alt" /> Delete</button>);
    }
    const editDeleteOverlay = (      
      <Popover placement="bottom" target={"editDeleteScoringSets_po"} isOpen={this.state.showEditDelete} toggle={this.onShowEditDeleteOverlay} className="ml-0">
        <PopoverBody>
          <button className="dropdown-item ecd-option" onClick={this.onEditClick}><i className="fas fa-edit" />  Edit</button>
          <button className="dropdown-item ecd-option" onClick={this.onCloneClick}><i className="fas fa-clone" />  Clone</button>
          {deleteOption}
        </PopoverBody>
      </Popover>
    );
    const id = "scoreSets_tt";
    const ttOverlay = (<span className="d-flex control-spacer-left">
      <i className="fas fa-question-circle" id={id}></i>
      <UncontrolledTooltip placement={this.props.isStuck ? "bottom" : "top"} target={id}>Create new scoring combinations or access saved ones</UncontrolledTooltip>
    </span>);
    

    let displaySets = [...scoreSets];
    let hasCustomerScoreSets = false;
    let scoreDefaultsIndex;
    for(scoreDefaultsIndex = 0; scoreDefaultsIndex < scoreSets.length; scoreDefaultsIndex++){
      let isDefault = scoreSets[scoreDefaultsIndex].scoreConfig.isDefault
      hasCustomerScoreSets = !isDefault || hasCustomerScoreSets;
      if(isDefault) break;
    }

    if (scoreDefaultsIndex <= scoreSets.length - 1){
      displaySets.splice(scoreDefaultsIndex, 0, { id: 'default-label', type: "header", label: "System Defaults"});
    }
    if(hasCustomerScoreSets){
      if (scoreDefaultsIndex <= scoreSets.length - 1) {
        displaySets.splice(scoreDefaultsIndex, 0, {id: 'divider', type: "divider", label: "divider"});
      }
      displaySets.unshift({ id: 'customer-label', type: "header", label: "Brand Sets"});
    }
    return (
      <>
        <UseBackButton to="/scores/summary" />
        <PageCommands>
          <div className="section-title d-flex align-items-center mr-2">
            <span>Score Templates</span> {ttOverlay}
          </div>
          <span className="floating-control">
            <Dropdown
              disabled={requesting}
              items={displaySets}
              selected={scoreSet}
              renderItem={e => e.label ? e.label : e.scoreConfig.name}
              getKey={e => e.label ? e.id : e.scoreConfig._id.$oid}
              onSelected={this.onScoreSelect}
              menuClassName="cm-scoresettings-dropdown"
            />
          </span>
          {editDeleteOverlay}
          <button
            id="editDeleteScoringSets_po"
            ref={button => this.editDeleteOverlay = button }
            className="btn btn-outline-secondary control-spacer-left"
            disabled={scoreSet.scoreConfig.isDefault || requesting}
            onClick={!scoreSet.scoreConfig.isDefault ? this.onShowEditDeleteOverlay : undefined}>
            <i className="far fa-ellipsis-h"></i>
          </button>
          <button className="btn btn-secondary nowrap control-spacer-left" onClick={this.onCreateClick.bind(this)}>
            + Create Template
          </button>
        </PageCommands>
      </>
    );
  }
}

ScoreSetsHeader.propType = {
  accounts: PropTypes.array.isRequired,
  verticals: PropTypes.array.isRequired,
  requesting: PropTypes.bool.isRequired,
  scoreSets: PropTypes.array.isRequired,
  scoreSetsDefaults: PropTypes.array.isRequired,
  scoreConfigTemplate: PropTypes.object.isRequired,
  selectedScoreSet: PropTypes.number,
  onSelectedScoreSetChange: PropTypes.func.isRequired,
};
export default ScoreSetsHeader;

